var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63314 9.05841C7.54981 9.05008 7.44981 9.05008 7.35814 9.05841C5.3748 8.99175 3.7998 7.36675 3.7998 5.36675C3.7998 3.32508 5.4498 1.66675 7.49981 1.66675C9.54147 1.66675 11.1998 3.32508 11.1998 5.36675C11.1915 7.36675 9.61647 8.99175 7.63314 9.05841Z",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.6752 3.3335C15.2919 3.3335 16.5919 4.64183 16.5919 6.25016C16.5919 7.82516 15.3419 9.1085 13.7836 9.16683C13.7169 9.1585 13.6419 9.1585 13.5669 9.16683",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4666 12.1333C1.44993 13.4833 1.44993 15.6833 3.4666 17.0249C5.75827 18.5583 9.5166 18.5583 11.8083 17.0249C13.8249 15.6749 13.8249 13.4749 11.8083 12.1333C9.52494 10.6083 5.7666 10.6083 3.4666 12.1333Z",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.2832 16.6667C15.8832 16.5417 16.4499 16.3001 16.9165 15.9417C18.2165 14.9667 18.2165 13.3584 16.9165 12.3834C16.4582 12.0334 15.8999 11.8001 15.3082 11.6667",
    stroke: "#010E20",
    strokeWidth: 1.24699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPlatform);
export default __webpack_public_path__ + "static/media/menuPlatform.96cc15182329e939af86f28b75a1ce47.svg";
export { ForwardRef as ReactComponent };